module.exports = __webpack_public_path__ + "img/combo burrito.58182535.jpeg";